import React, { useEffect, useRef } from 'react';
import TableComponent from '../../../../../../../../../generic/table/TableComponent';
import './style.scss';

const ApplicationListDrilldown = ({ tableData, onSort, handleToggleModal, handleScroll }) => {

    const tableRef = useRef();

    useEffect(() => {
        const tableElement = tableRef.current;

        const handleScrollEvent = () => {
            const { scrollTop, clientHeight, scrollHeight } = tableElement;
            const bottomOffset = scrollTop + clientHeight + 2;
            if (bottomOffset >= scrollHeight) {
                handleScroll();
            }
        };
        tableElement.addEventListener('scroll', handleScrollEvent);

        return () => {
            tableElement.removeEventListener('scroll', handleScrollEvent);
        };
    }, [handleScroll, tableData]);

    return (
        <div className='application-list'>
            <div className='application-list__header'>
                <h3>Applications</h3>
                <p>
                    <svg onClick={handleToggleModal} xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M10.4151 1.84385C10.4728 1.7883 10.5185 1.72233 10.5497 1.64972C10.5809 1.57711 10.597 1.49928 10.5971 1.42066C10.5971 1.34205 10.5811 1.26419 10.55 1.19155C10.5189 1.1189 10.4732 1.05288 10.4157 0.997254C10.3581 0.941631 10.2898 0.897495 10.2146 0.867366C10.1393 0.837237 10.0587 0.821705 9.97726 0.821657C9.89581 0.821609 9.81515 0.837045 9.73989 0.867085C9.66463 0.897124 9.59623 0.941179 9.5386 0.996733L5.79846 4.60688L2.05939 0.996733C1.94301 0.884398 1.78516 0.821289 1.62057 0.821289C1.45599 0.821289 1.29814 0.884398 1.18176 0.996733C1.06538 1.10907 1 1.26143 1 1.42029C1 1.57916 1.06538 1.73152 1.18176 1.84385L4.92191 5.45296L1.18176 9.06207C1.12414 9.1177 1.07843 9.18373 1.04724 9.2564C1.01605 9.32908 1 9.40697 1 9.48563C1 9.5643 1.01605 9.64219 1.04724 9.71486C1.07843 9.78754 1.12414 9.85357 1.18176 9.90919C1.29814 10.0215 1.45599 10.0846 1.62057 10.0846C1.70207 10.0846 1.78277 10.0691 1.85806 10.039C1.93335 10.0089 2.00176 9.96482 2.05939 9.90919L5.79846 6.29904L9.5386 9.90919C9.65498 10.0214 9.81277 10.0844 9.97726 10.0843C10.1417 10.0842 10.2995 10.021 10.4157 9.90867C10.5319 9.79634 10.5972 9.64404 10.5971 9.48527C10.597 9.3265 10.5315 9.17427 10.4151 9.06207L6.675 5.45296L10.4151 1.84385Z" fill="#F1F4F9" stroke="black" strokeWidth="0.2" />
                    </svg>
                </p>
            </div>
            <div className='application-list__table' ref={tableRef} style={{ overflowY: 'scroll', height: '500px' }}>
                <TableComponent tableData={tableData} onSort={onSort} />
            </div>
        </div>
    )
}

export default ApplicationListDrilldown;